// Mirrors optroImportWizardContext for the controls Optro wizard: selection
// state, plus the per-row workpaper decision, shared between the select and
// review steps.
import { createContext, useContext } from "react";
import {
  OptroOpsAuditSummary,
  OptroWorkStepSummary,
  WorkStepWorkpaperDecision,
} from "../../../../models/audit/workStep";

export interface OptroWorkStepImportWizardValue {
  // Audits chosen on the wizard's first step; the work-step step lists items
  // scoped to exactly these (one accordion group per audit).
  selectedAudits: OptroOpsAuditSummary[];
  toggleAudit: (audit: OptroOpsAuditSummary) => void;
  isAuditSelected: (id: number) => boolean;
  selected: OptroWorkStepSummary[];
  toggleWorkStep: (workStep: OptroWorkStepSummary) => void;
  isSelected: (externalRef: string) => boolean;
  selectMany: (workSteps: OptroWorkStepSummary[]) => void;
  deselectMany: (externalRefs: string[]) => void;
  clearSelection: () => void;
  // Keyed by external ref, exactly as controls keys `workpaperDecisions`.
  // The review step seeds every selected ref with an explicit pick of its
  // Optro files as they are fetched; a ref still without an entry imports
  // with `DEFAULT_WORKPAPER_DECISION` — all of its Optro files.
  workpaperDecisions: Record<string, WorkStepWorkpaperDecision>;
  setWorkpapers: (
    externalRef: string,
    decision: WorkStepWorkpaperDecision,
  ) => void;
}

export const OptroWorkStepImportWizardContext =
  createContext<OptroWorkStepImportWizardValue | null>(null);

export function useOptroWorkStepImportWizard(): OptroWorkStepImportWizardValue {
  const value = useContext(OptroWorkStepImportWizardContext);
  if (!value) {
    throw new Error(
      "useOptroWorkStepImportWizard must be used within OptroWorkStepImportWizardLayout",
    );
  }
  return value;
}
